import { VideoWithOptionalText } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock VideoWithOptionalText
 * @param overrides - Partial fields to override defaults
 * @returns Complete VideoWithOptionalText mock
 */
export function createVideoWithOptionalText(
  overrides: Partial<VideoWithOptionalText> = {}
): VideoWithOptionalText {
  return {
    _uid: 'e3ac569b-5187-473f-80b3-3c89a58fde15',
    video: createStoryblokAsset({
      id: 10354892,
      alt: 'sdasddssd',
      title: 'saasddds',
      filename:
        'https://a.storyblok.com/f/235453/x/6213947d4c/samplevideo_720x480_1mb.mp4',
      src: 'https://a.storyblok.com/f/235453/x/6213947d4c/samplevideo_720x480_1mb.mp4',
      width: 720,
      height: 480,
      aspect_ratio: 1.5,
      content_type: 'video/mp4',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    subline: 'dsaasd',
    headline: 'asdasdsd',
    component: 'video-with-optional-text',
    _editable:
      '<!--#storyblok#{"name": "video-with-optional-text", "space": "235453", "uid": "e3ac569b-5187-473f-80b3-3c89a58fde15", "id": "322787899"}-->',
    ...overrides,
  }
}

/**
 * Creates a mock VideoWithOptionalText for YouTube
 */
export function createYoutubeWithOptionalText(
  overrides: Partial<VideoWithOptionalText> = {}
): VideoWithOptionalText {
  return {
    _uid: 'e3ac569b-5187-473f-80b3-3c89a58fde15',
    video: undefined,
    youtube: 'https://www.youtube.com/watch?v=tgbNymZ7vqY',
    subline: 'dsaasd',
    headline: 'asdasdsd',
    component: 'video-with-optional-text',
    _editable:
      '<!--#storyblok#{"name": "video-with-optional-text", "space": "235453", "uid": "e3ac569b-5187-473f-80b3-3c89a58fde15", "id": "322787899"}-->',
    ...overrides,
  }
}
